import React, {useEffect} from 'react';
import {
    setFilter,
    setForm,
    setItem,
    setLoading,
    setTableParams,
    setViewMode
} from "../../../redux/actions/generics/IndexedActions";
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import {Card, CardBody, CardTitle} from "reactstrap";
import {LIST} from "../../../components/i18n/i18n";
import {GenericButton} from "../../../components/buttons/customButtons";
import CategoryFilters from "./_filters";
import {categoryService} from "../../../jwt/_services/clasificator/categoryService";
import CategoryForm from "./_form";
import {ColorFormatter} from "../../../components/tables/colorFormatter";
import {ActiveFormatter} from "../../../components/tables/activeFormater";
import TableAdapter from "../../../components/TableAdapter/TableAdapter";
import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";

const CategoryList = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { app, udn, pageSize, pageIndex, totalSize, listDomainObjects, filter } = componentState?.data;

    useEffect( () => {
        if( !app.id || filter)
            return

        let dataRequest = {
            fbDataBase : { id : app?.fbDataBase?.id },
            onlyRegistered : true,
            item : {
            }
        }

        if (app.code !== 'PARK' && udn.id) {
            dataRequest.item.udn = { id : udn.id }
        }

        props.setFilter(path , dataRequest);
    }, [ app, udn ]);

    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, categoryService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter ]);


    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams(path, tableChangeParams.sizePerPage, currentIndex, totalSize, currentIndex );
    };

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path);
        ModalFormContainer( CategoryForm, { path } )
    }

    const editItem = (data) => {
        props.setForm(path, true, false, false);
        props.setItem(path, data);

        ModalFormContainer(CategoryForm, { path, data, Form: CategoryForm })
    };

    const confirmDelete = (data) => {
        return ConfirmDelete({ remove : genericIndexedActions.delete , data : data, fbDataBaseId :  app?.fbDataBase?.id, service: categoryService } );
    };

    const colorFormatter = (cell) => {
        return (
            <ColorFormatter color={cell}/>
        );
    }

    const activeFormatter = (cell) => {
        return (
            <ActiveFormatter active={cell}/>
        );
    }

    const actionsFormatter = (cell, row) => <div key={`action-${row?.id}`}>
        <GenericButton style={'table'} toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
        <GenericButton style={'danger-secondary'} toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
    </div>

    const columns = [{
        dataField: 'id',
        text: 'ID',
        headerStyle: {width: '0px'},
        hidden: true
    }, {
        dataField: 'uid',
        text: 'UID'
    }, {
        dataField: 'name',
        text: 'Nombre'
    }, {
        dataField: 'code',
        text: 'Código'
    }, {
        dataField: 'isExtraordinary',
        text: "Extraordinaria",
        formatter: activeFormatter
    }, {
        dataField: 'status',
        text: "Activo",
        formatter: activeFormatter
    }, {
        isDummyField: true,
        text: 'Acción',
        headerStyle: {width: '180px'},
        formatter: actionsFormatter
    }
    ];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{LIST}
            <div className="float-right">
                <GenericButton
                    style={'table'}
                    label={'Agregar'}
                    toolTip={'Agregar'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={createItem}
                />
            </div>
        </CardTitle>
        <CardBody className="">
            <CategoryFilters path={path}/>
            <TableAdapter
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects}
                columns={columns}
                pagination={{pageIndex, pageSize, totalSize}}
                onTableChange={handleTableChange}
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    setLoading,
})
export default connect(mapStateToProps, mapActionsToProps)(CategoryList)